import React, { memo, useContext, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactDOM, { render } from 'react-dom';
import {
  CardHeader,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
} from 'reactstrap';
import { FaArrowCircleRight, FaTrash, FaInfoCircle } from 'react-icons/fa';

import { PropostaConfiguracao } from 'models/PropostaConfiguracao';
import { PropostaMaterial } from 'models/PropostaMaterial';
import toast from 'react-hot-toast';
import api from 'services/api';

import Orcamento from 'models/Orcamento';
import { useQuery } from 'react-query';
import { Checkbox, CircularProgress, Tooltip } from '@material-ui/core';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { PropostaContext } from 'views/pages/Proposta';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import InputSelect from 'components/InputSelect';
import mensagemAtingirMeta from 'utils/mensagemAtingirMeta';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import ProdutoModel from 'models/Produto';
import formatCurrency from 'utils/formatCurrency';
import { Th, Td } from './styles';
import MaterialItem from '../MaterialItem';
import MaterialTotalItem from '../MaterialTotalItem';
import { MateriaisContext, PropostaMateriaisSelecao } from '../..';

interface ConfiguracaoMaterial {
  registros: {
    atividade: number;
    materiais: PropostaMaterial[];
    total: number;
  }[];
  total: number;
}

interface PropostaMaterialExtends extends PropostaMaterial {
  isFatDireto?: boolean;
}

function PropostaConfiguracaoMaterial({
  propostaConfiguracao,
  atualizar,
  isFaturamentoDireto,
  campoBusca,
  setPropostaMaterialSelecionado,
  propostaMaterialSelecionado,
  mostrarSelecao,
  precificacao,
  totalSetorAtividadeAcesso,
}: {
  propostaConfiguracao: PropostaConfiguracao;
  atualizar: () => void;
  isFaturamentoDireto: boolean;
  campoBusca: string[];
  setPropostaMaterialSelecionado: React.Dispatch<
    React.SetStateAction<PropostaMateriaisSelecao[]>
  >;
  propostaMaterialSelecionado: PropostaMateriaisSelecao[];
  mostrarSelecao: boolean;
  precificacao: any[];
  totalSetorAtividadeAcesso: ValidarAcessoPrograma;
}): JSX.Element {
  const { loadingMateriais, setLoadingMateriais } =
    useContext(MateriaisContext);
  const {
    propostaConfiguracoes,
    setPropostaConfiguracoes,
    permiteModificacao,
    setTriggerMaterialCheck,
    acessoLimitado,
    propostaVersao,
  } = useContext(PropostaContext);

  const [materiais, setMateriais] = useState<ConfiguracaoMaterial>();
  const [configuracao, setConfiguracao] = useState<Orcamento>();
  // const registros = materiais?.registros;
  const valorTotalConfiguracao = materiais?.total || 0;
  let valorTotalSetorAtividade = 0;

  const pivoCentral = propostaConfiguracao.fichaTecnica?.pivoCentral || '-';
  const [deletingMaterial, setDeletingMaterial] = useState(false);
  const [deletingConfiguracao, setDeletingConfiguracao] = useState(false);
  const [reprocessando, setReprocessando] = useState(false);

  const [tiposExclusao, setTiposExclusao] = useState([]);

  const [acessoLimitadoListaMateriais, setAcessoLimitadoListaMateriais] =
    useState(true);

  async function retornaPropostaConfiguracaoMateriais(): Promise<ConfiguracaoMaterial> {
    const response = await api.get(
      `/proposta/configuracao/${propostaConfiguracao.id}/materiais`,
    );

    const registrosResp = response.data.registros;

    return response.data;
  }

  async function retornaProduto(): Promise<ProdutoModel[]> {
    const response = await api.get(
      `/produto/configuracao/${propostaConfiguracao.orcamentoId}`,
    );

    return response.data;
  }

  async function retornaPropostaConfiguracaoMateriaisMarcadosPropVerAnterior() {
    const response = await api.get(
      `/proposta/configuracao/${propostaConfiguracao.id}/materiais`,
    );

    const registrosResp = response.data.registros;
    /**
     *
    const fatDiretoVersaoOriginal: number[] = registrosResp.flatMap(
      (item: any) =>
      item.materiais
      .filter((mat: any) => mat.selecionadoFatDireto === true)
      .map((mat: any) => mat.id),
    );
    */
    const orcamentoMaterialFatDirOriginal: PropostaMateriaisSelecao[] =
      registrosResp.flatMap((item: any) =>
        item.materiais
          .filter((mat: any) => mat.selecionadoFatDireto)
          .map((mat: any) => ({
            desconto: mat.desconto,
            id: mat.id,
            isAvulso:
              (mat.criadoManualmente ||
                mat.importacaoMaterial ||
                mat.importacaoMaterialId) ??
              false,
            isFaturamentoDireto: mat.selecionadoFatDireto,
          })),
      );

    setPropostaMaterialSelecionado(prev => [
      ...prev,
      ...orcamentoMaterialFatDirOriginal,
    ]);
    // setCheckedIds(prev => new Set([...prev, ...fatDiretoVersaoOriginal]));
  }

  const { data: dataMateriais, isLoading: isLoadingMateriais } = useQuery(
    `proposta-configuracao-materiais-${propostaConfiguracao.id}`,
    async () => {
      const materiaisResponse = await retornaPropostaConfiguracaoMateriais();
      return materiaisResponse;
    },
    {
      refetchOnMount: false, // não refetchar ao remontar
    },
  );

  const { data: dataConfiguracao, isLoading: isLoadingConfiguracao } = useQuery(
    `configuracao-${propostaConfiguracao.orcamentoId}`,
    async () => {
      async function carregaConfiguracao(): Promise<Orcamento> {
        const response = await api.get(
          `/orcamento/${propostaConfiguracao.orcamentoId}`,
        );
        return response.data;
      }

      const dataConfiguracaoResponse = await carregaConfiguracao();
      return dataConfiguracaoResponse;
    },
  );

  const { data: dataProduto, isLoading: isLoadingProduto } = useQuery(
    `proposta-produto-${propostaConfiguracao.orcamentoId}`,
    async () => {
      const produtoResponse = await retornaProduto();
      return produtoResponse[0];
    },
    {
      // refetchOnMount: false, // não refetchar ao remontar
    },
  );

  useEffect(() => {
    setLoadingMateriais(isLoadingMateriais);
  }, [isLoadingMateriais]);

  useEffect(() => {
    if (dataMateriais) {
      setMateriais(dataMateriais);
    }
  }, [dataMateriais]);

  useEffect(() => {
    async function fetchMateriais() {
      const val = await retornaPropostaConfiguracaoMateriais();
      setMateriais(val);
    }

    fetchMateriais();
  }, []);

  useEffect(() => {
    if (dataConfiguracao) {
      setConfiguracao(dataConfiguracao);
    }
  }, [dataConfiguracao]);

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 60,
      },
    });
    setAcessoLimitadoListaMateriais(response.data);
  }

  useEffect(() => {
    getAcessoLimitadoPrograma();
  }, []);

  async function getTiposExclusao() {
    const response = await api.get(`/tipo-exclusao/tipos`);
    setTiposExclusao(response.data);
  }

  useEffect(() => {
    getTiposExclusao();
    retornaPropostaConfiguracaoMateriaisMarcadosPropVerAnterior();
  }, []);

  useEffect(() => {
    if (deletingMaterial) {
      toast.loading(
        `Excluindo item da configuração ${propostaConfiguracao.orcamentoId}...`,
        { position: 'top-right' },
      );
      return;
    }

    toast.dismiss();
  }, [deletingMaterial]);

  function handleOnAddFinanciamentoDireto(propostaMaterial: PropostaMaterial) {
    setPropostaMaterialSelecionado(prev => {
      const existe = prev.find(item => item.id === propostaMaterial.id);

      if (existe) {
        return prev.filter(item => item.id !== propostaMaterial.id);
      }
      return [
        ...prev,
        {
          id: propostaMaterial.id,
          desconto: propostaMaterial?.desconto ?? 0,
          isAvulso: false,
          isFaturamentoDireto,
          codigo:
            propostaMaterial.material.codigoSap ??
            propostaMaterial.material.diteCodigo,
          fabricanteDesc: propostaMaterial.material.descricaoFabrSge,
        },
      ];
    });
  }

  async function handleDeletePropostaConfiguracaoMaterial(
    propostaConfiguracaoMaterial: PropostaMaterial,
  ) {
    async function deletePropostaConfiguracaoMaterial(
      tipoExclusaoId: string,
      motivo: string,
    ) {
      try {
        setDeletingMaterial(true);

        await api.post('tipo-exclusao/salvar-excluir-materiais-proposta', {
          orcamentoId: propostaConfiguracao.orcamentoId,
          propostaConfiguracaoId: propostaConfiguracao.id,
          idMaterial: propostaConfiguracaoMaterial.id,
          motivo,
          tipoExclusao: tipoExclusaoId,
        });

        setDeletingMaterial(false);
        setLoadingMateriais(true);
        const materiaisResponse = await retornaPropostaConfiguracaoMateriais();
        setMateriais(materiaisResponse);
      } finally {
        setDeletingMaterial(false);
        setLoadingMateriais(false);
        setTriggerMaterialCheck(true);
      }
    }

    async function openModal() {
      const wrapper = document.createElement('div');

      Swal.fire({
        title: `Excluir item da configuração ${propostaConfiguracao.orcamentoId}?`,
        html: wrapper,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, excluir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
        preConfirm: () => {
          const motivoInput = document.querySelector(
            '#motivo-input',
          ) as HTMLInputElement;

          const selectedTipo = document.querySelector(
            '#tipos_exclusao',
          ) as HTMLSelectElement;

          const motivo = motivoInput?.value;
          const tipo = selectedTipo?.value;

          if (!tipo || tipo.trim() === '') {
            Swal.showValidationMessage('Selecione um tipo de exclusão válido.');
            return false;
          }

          return { motivo, tipo };
        },
      }).then(async result => {
        if (result.isConfirmed && result.value) {
          const { motivo, tipo } = result.value;
          deletePropostaConfiguracaoMaterial(tipo, motivo);
          await mensagemAtingirMeta(
            `Foi removido um material da proposta`,
            Number(propostaConfiguracao.propostaVersaoId),
          );
        }
      });

      const selectOptions = tiposExclusao
        .filter((tipo: any) => tipo.indicTipoExclusao)
        .map((tipo: any) => ({
          value: tipo.id,
          name: tipo.descricao,
        }));

      ReactDOM.render(
        <div>
          <strong>Selecione o motivo da exclusão*:</strong>
          <InputSelect id="tipos_exclusao" options={selectOptions} />
          <br />
          <strong>Complemento da exclusão do material:</strong>
          <input
            id="motivo-input"
            className="swal2-input"
            placeholder="Complemento da exclusão"
          />
        </div>,
        wrapper,
      );
    }

    openModal();
  }

  async function handleDeletePropostaConfiguracao(
    propostaConfiguracaoHandle: PropostaConfiguracao,
  ) {
    async function deletePropostaConfiguracao() {
      try {
        setDeletingConfiguracao(true);

        await mensagemAtingirMeta(
          `Foi excluída uma configuração da proposta`,
          Number(propostaConfiguracaoHandle.propostaVersaoId),
        );

        Swal.fire({
          icon: 'info',
          text: `Excluindo a configuração desta versão`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        await api.delete(
          `/proposta/configuracao/${propostaConfiguracaoHandle.id}`,
        );
        setDeletingConfiguracao(false);

        setPropostaConfiguracoes(
          propostaConfiguracoes.filter(
            item => item.id !== propostaConfiguracaoHandle.id,
          ),
        );

        // Dispara o processo para atualizar a lista de configurações
        atualizar();

        toast.success('Feito!', {});
        Swal.close();
      } catch (error: any) {
        Swal.fire({
          icon: 'error',
          title: 'Ops!',
          text:
            error?.response?.data?.message ??
            'Não foi possível prosseguir com a exclusão',
        });
      } finally {
        setDeletingConfiguracao(false);
        setTriggerMaterialCheck(true);
      }
    }

    Swal.fire({
      title: `Excluir a configuração ${propostaConfiguracaoHandle.orcamentoId} desta versão da proposta?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, excluir`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(result => {
      if (result.isConfirmed) {
        deletePropostaConfiguracao();
      }
    });
  }

  const materiaisFiltrados = !materiais?.registros?.length
    ? []
    : materiais.registros.flatMap(configMaterial => {
        const { materiais: configMateriais } = configMaterial;

        const filtrados =
          campoBusca && campoBusca.length > 0
            ? configMateriais.filter(item => {
                const fabName = (
                  item.material?.fabrNome ||
                  item.material?.descricaoFabrSge ||
                  ''
                ).toUpperCase();
                return campoBusca.some(busca =>
                  fabName.includes(busca.toUpperCase()),
                );
              })
            : configMateriais;

        return filtrados;
      });

  function handleToggleAll(checked: boolean) {
    setPropostaMaterialSelecionado(prev => {
      if (checked) {
        const novos = materiaisFiltrados.filter(
          m => !prev.some(p => p.id === m.id),
        );

        const adicionados = novos.map(m => ({
          id: m.id,
          desconto: m.desconto ?? 0,
          isAvulso: false,
          isFaturamentoDireto,
          codigo: m.material.codigoSap ?? m.material.diteCodigo,
          fabricanteDesc: m.material.descricaoFabrSge,
        }));

        return [...prev, ...adicionados];
      }
      return prev.filter(p => !materiaisFiltrados.some(m => m.id === p.id));
    });
  }

  function bodyMateriais() {
    if (loadingMateriais) {
      return (
        <tr>
          <h5 className="m-3">
            Carregando... <CircularProgress size={14} className="ml-3" />
          </h5>
        </tr>
      );
    }

    if (!materiais?.registros?.length) {
      return (
        <tr>
          <Td className="text-center" colSpan={5}>
            Nenhum registro encontrado
          </Td>
        </tr>
      );
    }

    const materiaisAgrupados = materiaisFiltrados.reduce((acc, material) => {
      const { produtoAtividadeId } = material;
      if (!produtoAtividadeId) return acc;
      if (!acc[produtoAtividadeId]) {
        acc[produtoAtividadeId] = [];
      }
      acc[produtoAtividadeId].push(material);
      return acc;
    }, {} as Record<number, PropostaMaterialExtends[]>);

    const calcularTotal = (propMaterial: PropostaMaterialExtends[]) =>
      propMaterial.reduce((soma, mat) => soma + (mat.valorTotal ?? 0), 0);

    return (
      <>
        {Object.entries(materiaisAgrupados).map(
          ([produtoAtividadeId, propMaterial]) => {
            const totalAtividade = calcularTotal(propMaterial);
            const ativ = propMaterial[0].produtoAtividade;
            const percRelativoAtividade =
              (totalAtividade * 100) / valorTotalConfiguracao;
            const orcamentoId = propostaConfiguracao?.orcamentoId;
            const valorFinalPrec =
              precificacao.find(item => item.configuracaoId === orcamentoId)
                ?.valorFinalComOutros ?? 0;
            const valorRelativoAtividadeValorTotalProposta =
              ((valorFinalPrec ?? 0) * percRelativoAtividade) / 100;

            valorTotalSetorAtividade +=
              valorRelativoAtividadeValorTotalProposta ?? 0;

            return (
              <React.Fragment key={ativ}>
                {propMaterial.map(propostaMaterial => (
                  <MaterialItem
                    key={propostaMaterial.id}
                    propostaMaterial={propostaMaterial}
                    canDelete={permiteModificacao}
                    disabled={deletingMaterial}
                    onClickDelete={() =>
                      handleDeletePropostaConfiguracaoMaterial(propostaMaterial)
                    }
                    acessoLimitadoListaMateriais={acessoLimitadoListaMateriais}
                    acessoLimitado={acessoLimitado}
                    isFaturamentoDireto={isFaturamentoDireto}
                    mostrarSelecao={mostrarSelecao}
                    onAddFinanciamentoDireto={() =>
                      handleOnAddFinanciamentoDireto(propostaMaterial)
                    }
                    setPropostaMaterialSelecionado={
                      setPropostaMaterialSelecionado
                    }
                    propostaMaterialSelecionado={propostaMaterialSelecionado}
                  />
                ))}

                {(!campoBusca || campoBusca.length === 0) && (
                  <MaterialTotalItem
                    texto={`Preço Líq. da atividade ${
                      ativ ? traduzirProdutoAtividade(ativ, true) : ''
                    }`}
                    valor={formatCurrency(arredondaDecimais(totalAtividade))}
                    acessoLimitadoListaMateriais={acessoLimitadoListaMateriais}
                    elementType={
                      totalSetorAtividadeAcesso.temAcesso ? 'h3' : 'h3'
                    }
                  />
                )}
                {(!campoBusca || campoBusca.length === 0) &&
                  totalSetorAtividadeAcesso.temAcesso && (
                    <MaterialTotalItem
                      texto={`Preço total da atividade ${
                        ativ ? traduzirProdutoAtividade(ativ, true) : ''
                      }`}
                      valor={formatCurrency(
                        arredondaDecimais(
                          valorRelativoAtividadeValorTotalProposta,
                        ),
                      )}
                      acessoLimitadoListaMateriais={
                        acessoLimitadoListaMateriais
                      }
                      elementType="h2"
                    />
                  )}
              </React.Fragment>
            );
          },
        )}
      </>
    );
  }

  return (
    <>
      <CardHeader>
        <Row>
          <Col sm="7">
            <h4 className="mb--1">{dataProduto?.nome ?? ''}</h4>
            <small className="text-muted">
              Configuração {propostaConfiguracao.orcamentoId}
            </small>
            {isLoadingConfiguracao ? (
              <CircularProgress size={12} className="ml-2" />
            ) : (
              configuracao && (
                <Link
                  className="ml-2"
                  to={{
                    pathname: `/admin/cadastro-orcamento-novo`,
                    state: {
                      orcamento: configuracao,
                    },
                  }}
                >
                  <FaArrowCircleRight size={15} />
                </Link>
              )
            )}
          </Col>
          <Col sm="5">
            {permiteModificacao && (
              <Button
                className="btn-icon btn-2 float-right"
                color="danger"
                outline
                type="button"
                size="sm"
                title="Remover configuração"
                disabled={deletingConfiguracao || reprocessando}
                onClick={() =>
                  handleDeletePropostaConfiguracao(propostaConfiguracao)
                }
              >
                <FaTrash />
              </Button>
            )}
          </Col>
        </Row>
      </CardHeader>

      <Card>
        <CardBody className="p-1">
          <Table bordered responsive>
            <thead>
              <tr>
                <Th>Ativ</Th>
                <Th>Item</Th>
                <Th className="text-center">Qtd</Th>
                <Th className="text-center" style={{ width: '5%' }}>
                  Desconto(%)
                </Th>
                {!acessoLimitadoListaMateriais && (
                  <>
                    <Th className="text-right">Valor unitário</Th>
                    <Th className="text-right">Valor total</Th>
                    {permiteModificacao && !mostrarSelecao && <Th />}
                  </>
                )}
                {mostrarSelecao && (
                  <Th className="text-center w-auto" style={{ width: '80px' }}>
                    <Checkbox
                      color="primary"
                      className="mr-1 float-center"
                      checked={
                        materiaisFiltrados.length > 0 &&
                        materiaisFiltrados.every(m =>
                          propostaMaterialSelecionado.some(p => p.id === m.id),
                        )
                      }
                      indeterminate={
                        materiaisFiltrados.some(m =>
                          propostaMaterialSelecionado.some(p => p.id === m.id),
                        ) &&
                        !materiaisFiltrados.every(m =>
                          propostaMaterialSelecionado.some(p => p.id === m.id),
                        )
                      }
                      title="Faturamento Direto"
                      onChange={e => handleToggleAll(e.target.checked)}
                    />
                  </Th>
                )}
              </tr>
            </thead>
            <tbody>{bodyMateriais()}</tbody>
            <tfoot>
              {(!campoBusca || campoBusca.length === 0) && (
                <MaterialTotalItem
                  texto="Total materiais"
                  valor={formatCurrency(valorTotalConfiguracao)}
                  elementType={
                    totalSetorAtividadeAcesso.temAcesso ? 'h3' : 'h2'
                  }
                  acessoLimitadoListaMateriais={acessoLimitadoListaMateriais}
                />
              )}
              {(!campoBusca || campoBusca.length === 0) &&
                totalSetorAtividadeAcesso.temAcesso && (
                  <MaterialTotalItem
                    texto="Total setores de atividade"
                    valor={formatCurrency(
                      arredondaDecimais(valorTotalSetorAtividade),
                    )}
                    elementType="h2"
                    acessoLimitadoListaMateriais={acessoLimitadoListaMateriais}
                  />
                )}
            </tfoot>
          </Table>
        </CardBody>
      </Card>
    </>
  );
}

export default PropostaConfiguracaoMaterial;
